module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1001-8a2dc258ccbcd39a89016ed68de0fdc5.png";